module.exports = __webpack_public_path__ + "img/muiden.7c0f2004.jpg";